"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _feesForPeriod2 = require("./fees-for-period");

var _feesForPeriod3 = _interopRequireDefault(_feesForPeriod2);

var _periodOfValidity2 = require("./period-of-validity");

var _periodOfValidity3 = _interopRequireDefault(_periodOfValidity2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param {V2.ExchangeData | V2.RefundData} time_period
 * @param {string} locale
 * @returns {V2.TimePeriod}
 */
// @ts-check

function timePeriod(time_period, locale) {
  var _feesForPeriod = (0, _feesForPeriod3.default)(time_period),
      fee = _feesForPeriod.fee,
      fee_simplified = _feesForPeriod.fee_simplified;

  var _periodOfValidity = (0, _periodOfValidity3.default)(time_period, locale),
      period = _periodOfValidity.period,
      period_simplified = _periodOfValidity.period_simplified;

  return { fee: fee, fee_simplified: fee_simplified, period: period, period_simplified: period_simplified };
}

exports.default = timePeriod;
module.exports = exports.default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy92Mi90aW1lLXBlcmlvZC5qcyJdLCJuYW1lcyI6WyJ0aW1lUGVyaW9kIiwidGltZV9wZXJpb2QiLCJsb2NhbGUiLCJmZWUiLCJmZWVfc2ltcGxpZmllZCIsInBlcmlvZCIsInBlcmlvZF9zaW1wbGlmaWVkIl0sIm1hcHBpbmdzIjoiOzs7Ozs7QUFFQTs7OztBQUNBOzs7Ozs7QUFFQTs7Ozs7QUFMQTs7QUFVQSxTQUFTQSxVQUFULENBQW9CQyxXQUFwQixFQUFpQ0MsTUFBakMsRUFBeUM7QUFBQSx1QkFDUCw2QkFBY0QsV0FBZCxDQURPO0FBQUEsTUFDL0JFLEdBRCtCLGtCQUMvQkEsR0FEK0I7QUFBQSxNQUMxQkMsY0FEMEIsa0JBQzFCQSxjQUQwQjs7QUFBQSwwQkFFRCxnQ0FBaUJILFdBQWpCLEVBQThCQyxNQUE5QixDQUZDO0FBQUEsTUFFL0JHLE1BRitCLHFCQUUvQkEsTUFGK0I7QUFBQSxNQUV2QkMsaUJBRnVCLHFCQUV2QkEsaUJBRnVCOztBQUd2QyxTQUFPLEVBQUVILFFBQUYsRUFBT0MsOEJBQVAsRUFBdUJDLGNBQXZCLEVBQStCQyxvQ0FBL0IsRUFBUDtBQUNEOztrQkFFY04sVSIsImZpbGUiOiJ0aW1lLXBlcmlvZC5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEB0cy1jaGVja1xuXG5pbXBvcnQgZmVlc0ZvclBlcmlvZCBmcm9tIFwiLi9mZWVzLWZvci1wZXJpb2RcIjtcbmltcG9ydCBwZXJpb2RPZlZhbGlkaXR5IGZyb20gXCIuL3BlcmlvZC1vZi12YWxpZGl0eVwiO1xuXG4vKipcbiAqIEBwYXJhbSB7VjIuRXhjaGFuZ2VEYXRhIHwgVjIuUmVmdW5kRGF0YX0gdGltZV9wZXJpb2RcbiAqIEBwYXJhbSB7c3RyaW5nfSBsb2NhbGVcbiAqIEByZXR1cm5zIHtWMi5UaW1lUGVyaW9kfVxuICovXG5mdW5jdGlvbiB0aW1lUGVyaW9kKHRpbWVfcGVyaW9kLCBsb2NhbGUpIHtcbiAgY29uc3QgeyBmZWUsIGZlZV9zaW1wbGlmaWVkIH0gPSBmZWVzRm9yUGVyaW9kKHRpbWVfcGVyaW9kKTtcbiAgY29uc3QgeyBwZXJpb2QsIHBlcmlvZF9zaW1wbGlmaWVkIH0gPSBwZXJpb2RPZlZhbGlkaXR5KHRpbWVfcGVyaW9kLCBsb2NhbGUpO1xuICByZXR1cm4geyBmZWUsIGZlZV9zaW1wbGlmaWVkLCBwZXJpb2QsIHBlcmlvZF9zaW1wbGlmaWVkIH07XG59XG5cbmV4cG9ydCBkZWZhdWx0IHRpbWVQZXJpb2Q7XG4iXX0=